(function () { 
    document.addEventListener("DOMContentLoaded", function () {
    const body = document.querySelector("body");
    const options = {
      attributes: true,
    };

    function callback(mutationList, observer) {
      mutationList.forEach(function (mutation) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          if (
            !mutation.target.className.includes("mini-cart--opening") &&
            mutation.target.className.includes("mini-cart--open")
          ) {
            validateAgreement();
          }
        }
      });
    }

    const observer = new MutationObserver(callback);
    observer.observe(body, options);


    function validateAgreement() {
      let agree = document.getElementById("agree");
      let checkout = document.getElementsByName("checkout")[0];
      
      if (checkout) checkout.disabled = !agree.checked;

      if (agree) {
        agree.onchange = function() {
          checkout.disabled = !this.checked;
  
          if (checkout.disabled) {
            document
              .querySelector('label[for="agree"')
              .classList.add("error");
            document.querySelector('.no-agreement').classList.add('opened');
          } else {
            document
              .querySelector('label[for="agree"')
              .classList.remove("error");
            document.querySelector('.no-agreement').classList.remove('opened');
          }
        };
      }
    }

    validateAgreement();
  });
})();
